import React, { useState } from 'react'
import { Link } from "react-router-dom"
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import users from '../img/users.svg';
import CustomDropdown from '../Components/CustomDropdown';
import UsersTable from "../Components/Datatables/UsersTable";


function Users() {
    const [selected, setSelected] = useState({
        option: "Aktív",
        key: "active",
    });
    const [isActive, setIsActive] = useState(false);

    const selectedOptions = [{ option: 'Mind', key: 'all' }, { option: 'Aktív', key: 'active' }, { option: 'Inaktív', key: 'inactive' }];

    return (
        <div className="page-content">
            <div className={isActive ? 'content-blur' : ""}></div>

            <div>
                <Row>
                    <Col xs lg="2" className="page-title"><img src={users} alt="users icon" /><h1>Felhasználók</h1></Col>
                    <Col className='right-content'>
                        <Link to="/newuser" >
                            <button className="custom-button"><span className="plus">+</span>Új felhasználó</button>
                        </Link>
                        <CustomDropdown selected={selected} setSelected={setSelected} options={selectedOptions} isActive={isActive} setIsActive={setIsActive} className={"dropdown"} />

                    </Col>
                </Row>
            </div>
            <UsersTable selected={selected} />
        </div>
    )

}

export default Users;
